var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rand-money',{attrs:{"title":_vm.title,"cur-class":_vm.curClass}})}
var staticRenderFns = []

export { render, staticRenderFns }